module.exports = __webpack_public_path__ + "static/media/Milk.a8ddb3a3.jpg";